import Translate from '@components/atoms/Translate/Translate'
import c from 'classnames'
import Text from '@components/atoms/Text'
import styles from './Header.module.scss'
import HeaderSteps from '@components/molecules/HeaderSteps'
import { useState } from 'react'
import LightBox from '@components/molecules/LightBox/LightBox'
import Button from '@components/molecules/Button/Button'
import config from '@config/'

const Header = () => {
  const [showCloseWarning, setShowCloseWarning] = useState(false)
  const handleClickX = () => {
    setShowCloseWarning(true)
  }

  const handleCancelCloseClick = () => {
    setShowCloseWarning(false)
  }
  const handleConfirmCloseClick = () => {
    if (!window.onCloseSujetApp) {
      console.warn(
        'No global close function defined. Please create a window.onCloseSujeApp function to be triggered'
      )
      return
    }
    window.onCloseSujetApp()
    setShowCloseWarning(false)
  }

  const { helpUrl } = config

  return (
    <div className={c([styles.base], 'b-brand10')}>
      {(showCloseWarning && (
        <LightBox
          title={<Translate str="header.close.title" />}
          body={<Translate str="header.close.text" />}
          buttons={
            <div className={styles.closeButtons}>
              <Button bg="white" underline onClick={handleCancelCloseClick}>
                <Translate str="header.close.ctaStay" />
              </Button>
              <Button bg="dark" onClick={handleConfirmCloseClick}>
                <Translate str="header.close.ctaConfirm" />
              </Button>
            </div>
          }
          onClose={handleCancelCloseClick}
        />
      )) ||
        null}
      <div className="o-grid">
        <div className={c(['o-grid__col', 'u-4/14@md', styles.row])}>
          <div className={styles.leftInner}>
            <Text type="text-l" bold>
              <Translate str="header.testSujet" />
            </Text>
          </div>
        </div>
        <div
          className={c(['o-grid__col', 'u-6/14@md', styles.row, styles.center])}
        >
          <HeaderSteps />
        </div>
        <div
          className={c(['o-grid__col', 'u-4/14@md', styles.row, styles.right])}
        >
          <div className={styles.rightInner}>
            <a href={helpUrl} rel="noreferrer" target="_blank">
              <div className={c(styles.help, 'c-dark')}>
                <div className={c(styles.helpIcon, 'c-brand10')}>
                  <Text type="text-xs" bold>
                    ?
                  </Text>
                </div>
                <Text type="text-xs" bold>
                  <Translate str="header.help" />
                </Text>
              </div>
            </a>
            <div className={styles.close} onClick={handleClickX}>
              <i className="icon icon-close" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
